export const SERVICE_TYPES = {
  PEAJE: 'peaje',
  LAVAAUTOS: 'lavaautos',
  GASOLINA: 'gasolina',
  PARQUEADERO: 'parqueadero',
  PARQUIMETRO: 'parquimetro',
  VENTA: 'venta'
};

// Configuraciones predefinidas para servicios conocidos
export const KNOWN_SERVICE_CONFIG = {
  'peaje': {
    id: 'peaje',
    mapId: 'map-wrapper-peaje',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5a3602e854206c07e7_peaje.png',
    clusterColor: '#FFD773',
    label: 'Peajes'
  },
  'lava-autos': {
    id: 'lavaautos',
    mapId: 'map-wrapper-lavaautos',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5a4d2ae2e17f3a3c3d_lavaautos.png',
    clusterColor: '#B179FF',
    label: 'Lavautos'
  },
  'lavaautos': {
    id: 'lavaautos',
    mapId: 'map-wrapper-lavaautos',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5a4d2ae2e17f3a3c3d_lavaautos.png',
    clusterColor: '#B179FF',
    label: 'Lavautos'
  },
  'gasolina': {
    id: 'gasolina',
    mapId: 'map-wrapper-gasolina',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5afb2b021053cba812_gasolina.png',
    clusterColor: '#FFAB74',
    label: 'Gasolina'
  },
  'parqueadero': {
    id: 'parqueadero',
    mapId: 'map-wrapper-parqueadero',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5afa16e1fb745e50a7_parqueadero.png',
    clusterColor: '#A0E1F0',
    label: 'Parqueaderos'
  },
  'parquimetros': {
    id: 'parquimetro',
    mapId: 'map-wrapper-parquimetro',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5ad3ac852e4cbb34b9_parquimetro.png',
    clusterColor: '#9AC4EF',
    label: 'Parquímetros'
  },
  'parquimetro': {
    id: 'parquimetro',
    mapId: 'map-wrapper-parquimetro',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6772dc5ad3ac852e4cbb34b9_parquimetro.png',
    clusterColor: '#9AC4EF',
    label: 'Parquímetros'
  },
  'punto-de-venta': {
    id: 'venta',
    mapId: 'map-wrapper-venta',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6819177cdc1dfa49b0223ec1_locations.png',
    clusterColor: '#c2d501',
    label: 'P. venta'
  },
  'venta': {
    id: 'venta',
    mapId: 'map-wrapper-venta',
    icon: 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6819177cdc1dfa49b0223ec1_locations.png',
    clusterColor: '#c2d501',
    label: 'P. venta'
  }
};

// Colores predefinidos para servicios nuevos (se rotan si hay más)
const DEFAULT_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
  '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52BE80'
];

// Icono por defecto para servicios nuevos
const DEFAULT_ICON = 'https://cdn.prod.website-files.com/6733bde60e89ed56a4840f90/6819177cdc1dfa49b0223ec1_locations.png';

/**
 * Genera una configuración dinámica para un servicio no conocido
 */
export const generateDynamicServiceConfig = (serviceName, index = 0) => {
  const normalizedName = serviceName.toLowerCase().trim();
  const sanitizedId = normalizedName.replace(/[^a-z0-9]/g, '-');
  
  return {
    id: sanitizedId,
    mapId: `map-wrapper-${sanitizedId}`,
    icon: DEFAULT_ICON,
    clusterColor: DEFAULT_COLORS[index % DEFAULT_COLORS.length],
    label: formatServiceLabel(serviceName),
    isDynamic: true
  };
};

/**
 * Formatea el nombre del servicio para mostrarlo como label
 */
const formatServiceLabel = (serviceName) => {
  return serviceName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Obtiene la configuración de un servicio, generándola dinámicamente si no existe
 */
export const getServiceConfig = (serviceName, index = 0) => {
  if (!serviceName) return null;
  
  const normalizedName = serviceName.toLowerCase().trim();
  
  // Buscar en configuraciones conocidas
  if (KNOWN_SERVICE_CONFIG[normalizedName]) {
    return KNOWN_SERVICE_CONFIG[normalizedName];
  }
  
  // Generar configuración dinámica
  return generateDynamicServiceConfig(serviceName, index);
};

/**
 * Obtiene todas las configuraciones de servicios únicos desde los datos
 */
export const getServiceConfigsFromData = (data) => {
  if (!data || data.length === 0) return {};
  
  // Obtener servicios únicos
  const uniqueServices = [...new Set(
    data
      .map(item => item.service)
      .filter(Boolean)
      .map(s => s.toLowerCase().trim())
  )];
  
  const configs = {};
  
  uniqueServices.forEach((serviceName, index) => {
    const config = getServiceConfig(serviceName, index);
    if (config) {
      configs[serviceName] = config;
    }
  });
  
  return configs;
};

